/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { NotificationSummary } from '@centecomm/portal-service';
import React from 'react';
import DynamicContent from 'Shared/PageElements/DynamicContent';
import DynamicTranslatedContent from 'Core/i18n/Components/DynamicTranslatedContent';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useDateFnsLocale } from 'Core/i18n/Hooks/useTranslationExtensions';
import styles from './notifications-panel.module.css';

export interface NotificationsListProps {
    notifications: NotificationSummary[];
    handleSelect: (notificationId: number) => void;
    children?: React.ReactNode;
}

function NotificationsList({
    notifications,
    handleSelect,
    children,
}: NotificationsListProps): React.ReactElement<NotificationsListProps> {
    const { t } = useTranslation('notificationsFeature');
    const dateFnsLocale = useDateFnsLocale();

    return (
        <DynamicContent
            loaded={!!notifications}
            noContent={notifications.length === 0}
            noContentMessage={t('notificationsFeature:noNotifications')}
        >
            <ul className={styles.NotificationList}>
                {notifications.map((notification) => (
                    <li className={`${styles.Notification}`} key={`notification-${notification.id}`}>
                        <div onClick={() => handleSelect(notification.id)}>
                            <p className={styles.Subject}>
                                <DynamicTranslatedContent
                                    content={notification.subject}
                                    showLoadingState
                                    extendedOptions={{
                                        bypassMainAppLanguage: true,
                                    }}
                                >
                                    {({ translatedContent }) => <>{translatedContent}</>}
                                </DynamicTranslatedContent>
                            </p>
                            <p className={styles.Date}>
                                {format(new Date(notification.created), 'Pp', { locale: dateFnsLocale })}
                            </p>
                        </div>
                    </li>
                ))}
                {children}
            </ul>
        </DynamicContent>
    );
}

export default NotificationsList;
